import React from 'react'
import NavBar from '../components/Home/NavBar'
import FormsOptions from '../components/Forms/FormsOptions.jsx'

const Forms = () => {
  return (
    <div className='bg-bgSteps h-screen'>
        <NavBar />
        <FormsOptions />
    </div>
  )
}

export default Forms